(() => {
  'use strict';

  const componentSelector = '[data-import-duties][data-required="true"]';
  const checkoutSelector = '[data-import-duties-checkout]';
  const acceleratedSelector = '[data-import-duties-accelerated]';
  const acceptedAttribute = 'Import duties accepted';
  const countryAttribute = 'Import duties accepted for';
  let savePromise = Promise.resolve();

  const components = () => Array.from(document.querySelectorAll(componentSelector));
  const activeComponent = () => components()[0] || null;
  const componentForCheckout = (checkout) => {
    const container = checkout.closest('cart-drawer, cart-notification, #main-cart-footer');
    return (container && container.querySelector(componentSelector)) || activeComponent();
  };

  function setError(component, message) {
    if (!component) return;
    const checkbox = component.querySelector('[data-import-duties-checkbox]');
    const error = component.querySelector('[data-import-duties-error]');
    component.classList.toggle('import-duties--error', Boolean(message));
    if (checkbox) checkbox.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
  }

  function updateInterface(country, accepted) {
    components().forEach((component) => {
      const matchesCountry = component.dataset.country === country;
      component.dataset.accepted = String(accepted && matchesCountry);
      const checkbox = component.querySelector('[data-import-duties-checkbox]');
      if (checkbox) checkbox.checked = accepted && matchesCountry;
      if (accepted && matchesCountry) setError(component, '');
    });

    document.querySelectorAll(acceleratedSelector).forEach((container) => {
      const relevant = container.dataset.country === country;
      container.hidden = relevant && !accepted;
    });
  }

  function saveAcceptance(country, accepted) {
    const attributes = {};
    attributes[acceptedAttribute] = accepted ? 'Yes' : '';
    attributes[countryAttribute] = accepted ? country : '';

    savePromise = fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes }),
    }).then((response) => {
      if (!response.ok) throw new Error(`Cart update failed (${response.status})`);
      return response.json();
    });

    return savePromise;
  }

  function showRequiredError(component) {
    const message = component.dataset.errorMessage;
    setError(component, message);
    component.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const checkbox = component.querySelector('[data-import-duties-checkbox]');
    if (checkbox) checkbox.focus({ preventScroll: true });
  }

  async function proceedToCheckout(component) {
    const checkbox = component.querySelector('[data-import-duties-checkbox]');
    if (!checkbox || !checkbox.checked) {
      showRequiredError(component);
      return;
    }

    try {
      await savePromise;
      if (component.dataset.accepted !== 'true') {
        showRequiredError(component);
        return;
      }
      window.location.assign('/checkout');
    } catch (error) {
      checkbox.checked = false;
      updateInterface(component.dataset.country, false);
      setError(component, 'We could not save your acknowledgement. Please try again.');
    }
  }

  document.addEventListener('change', async (event) => {
    const checkbox = event.target.closest('[data-import-duties-checkbox]');
    if (!checkbox) return;

    const component = checkbox.closest(componentSelector);
    if (!component) return;
    const accepted = checkbox.checked;
    updateInterface(component.dataset.country, false);
    checkbox.checked = accepted;

    try {
      await saveAcceptance(component.dataset.country, accepted);
      updateInterface(component.dataset.country, accepted);
    } catch (error) {
      updateInterface(component.dataset.country, false);
      setError(component, 'We could not save your acknowledgement. Please try again.');
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      const checkout = event.target.closest(checkoutSelector);
      if (!checkout) return;
      const component = componentForCheckout(checkout);
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!component) {
        window.location.assign('/checkout');
        return;
      }
      proceedToCheckout(component);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (!event.target.querySelector(checkoutSelector)) return;
      const component = componentForCheckout(event.target.querySelector(checkoutSelector));
      if (!component) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      proceedToCheckout(component);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    const component = activeComponent();
    if (!component) return;
    const accepted = component.dataset.accepted === 'true';
    updateInterface(component.dataset.country, accepted);
  });
})();
